import * as Sentry from '@sentry/react';

const app_environment = (window as any)?.env?.ENVIRONMENT_STATE;

Sentry.init({
  enabled: app_environment === 'production',
  dsn: 'https://6c68e2e14fef0556ea624fce4558db69@sentry.sanaap.co/17',
  integrations: [
    Sentry.replayIntegration({
      blockAllMedia: false,
      maskAllText: false,
      maskAllInputs: false,
    }),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
});
